import React from 'react';
import { FcManager } from "react-icons/fc";


const TopBar =({personnel}: any) =>{
    function refreshPage() {
        window.location.reload();
      }
    return(
        <div className="topbar-container">
            <div className="topbar-content">
                 <FcManager />
                <h3 className="topbar_content_h3">{personnel}</h3>
            </div>
            <div className="topbar-content">
                <h4 className="topbar_P_element">Dr. Omole</h4>
                <button onClick={refreshPage} className="topbarbutton_element">Logout</button>
            </div>
        </div>
    )
}

export default React.memo(TopBar);